import { Service } from '@roc/client-portal-shared/services';

const url = {
  GET_WIRE_AUTHORIZATION_INFO: '/api/v1/loan/public/wireAuthorization/getWireAuthInfo',
  CONFIRM_DOCUSIGN: '/api/v1/loan/public/wireAuthorization/confirmSignature',
  CONFIRM_NO_VERIFICATION: '/api/v1/loan/public/wireAuthorization/confirmNoVerification',
  CONSENT_REQUEST: '/api/v1/loan/public/wireAuthorization/consent',
  ASSOCIATE_VERIFICATION: '/api/v1/loan/public/wireAuthorization/associate'
};

export class WireAuthorizationService extends Service {
  getWireAuthInfo(requestId) {
    return this.get(`${url.GET_WIRE_AUTHORIZATION_INFO}?requestId=${requestId}`);
  }

  confirmSignature(request) {
    return this.put(`${url.CONFIRM_DOCUSIGN}`, request);
  }

  confirmNoVerification(request, identityDocumentFront: File, identityDocumentBack: File) {
    const requestPart = new Blob([JSON.stringify(request)], {
      type: 'application/json',
    });

    const formData = new FormData();
    formData.append('request', requestPart);
    formData.append('identityDocumentFront', identityDocumentFront);
    formData.append('identityDocumentBack', identityDocumentBack);

    return this.post(`${url.CONFIRM_NO_VERIFICATION}`, formData);
  }

  consentRequest(requestId) {
    return this.put(`${url.CONSENT_REQUEST}/${requestId}`, null);
  }
  associateVerification(requestId, sessionId) {
    return this.post(url.ASSOCIATE_VERIFICATION, {
      requestId,
      sessionId
    });
  }
}